module.exports = __webpack_public_path__ + "8d5b4ccd2b24eaac2dc4e2df920cd5d4.MP3";